import { useNavigate } from 'react-router';

import { ROUTES } from '@constants/routes';
import { recordGoogleAnalyticsEvent } from '@utils/helpers';

export const useFvtWelcomeCta = () => {
  const navigate = useNavigate();

  const onInviteCta = () => {
    recordGoogleAnalyticsEvent('User Interaction', 'CTA Click', 'BridgeBio FVT Proband Welcome');
    // TODO: branch on isLoggedIn when FVT auth is wired (SC-41044)
    navigate(ROUTES.FVT_LOGIN);
  };

  return { onInviteCta };
};
